





































































































import { Component, Vue } from 'vue-property-decorator';
import { 認証型 } from '@/type/authentication/authentication';
import {ja} from 'vuejs-datepicker/dist/locale';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';

import {
  納品データ検索依頼型,
  削除済検索対象区分型,
  納品データ検索依頼バリデータ一覧,
  未入庫納品伝票明細型,
  削除済区分型,
} from '@/type/stock/deliverydata/unstocked_deliverydata';
import { ValidationResult } from '@/type/validation/result';

import moment from 'moment';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import download from '@/infrastructure/api/download';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    NormalButton,
    AlertDialog,
  },
})
export default class ListUnstockedDeliveryData extends Vue {
  private 納品伝票明細一覧: 未入庫納品伝票明細型[] = [];
  private アラートメッセージ: string | string[] | null = null;

  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(納品データ検索依頼バリデータ一覧);

  private 納品データ検索依頼: 納品データ検索依頼型 = this.納品データ検索依頼初期値();
  private 選択中の行index: number|null = null;

  private created(): void {
    moment.locale('ja');
    this.initialize();
  }

  private initialize() {
    this.納品データ検索依頼 = this.納品データ検索依頼初期値();
    this.納品伝票明細一覧 = [];
    this.アラートメッセージ = null;
    this.選択中の行index = null;
  }

  private async 検索する(): Promise<void> {
    this.納品伝票明細一覧 = [];

    await api.未入庫納品伝票を検索する(this.納品データ検索依頼)
      .then((response: any) => {
        this.納品伝票明細一覧 = response.未入庫納品伝票明細一覧;
        if (this.納品伝票明細一覧.length === 0) {
          this.アラートメッセージ = '該当のデータはありません';
          this.$modal.show('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = response.アラートメッセージ;
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
        this.$modal.show('アラート');
      });
  }

  private 表示件数を取得(): number {
    return this.納品伝票明細一覧.length;
  }

  private beforeUpdate(): void {
    this.検索条件バリデーション結果.validate(this.納品データ検索依頼);
  }

  private 入力エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  private async 検索するハンドラ(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.検索する);
  }

  private 納品データ検索依頼初期値(): 納品データ検索依頼型 {
     return {
      伝票日付From: moment().startOf('month').toDate(),
      伝票日付To: null,
      削除済検索対象区分: 削除済検索対象区分型.削除済を含まない,
    };
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private クリアする(): void {
    this.initialize();
    this.ダイアログを閉じる('クリアダイアログ');
  }

  private async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    this.ダイアログを開く('出力ダイアログ');
  }

  private async 出力する(): Promise<void> {
    await download.納品データ未入庫照会一覧表を出力する('納品データ未入庫照会一覧.xlsx', this.納品データ検索依頼)
            .catch((error: any) => {
              this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
              this.$modal.show('アラート');
            });
    this.ダイアログを閉じる('出力ダイアログ');
  }

  private async 出力するハンドラ(): Promise<void> {
    await progress(this.出力する);
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  private async リスト選択時の処理(index: number) {
    this.選択中の行index = index;
  }

  private 削除済みである(未入庫納品伝票明細: 未入庫納品伝票明細型): boolean {
    return 未入庫納品伝票明細.商品登録済区分 === '未登録';
  }

  private 削除済項目(未入庫納品伝票明細: 未入庫納品伝票明細型): string {
    return 未入庫納品伝票明細.削除済区分 === 削除済区分型.削除済 ? '削除' : '';
  }

  private APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    if (!data.errors) {
      return メッセージ;
    }
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }
}
